import { render, staticRenderFns } from "./FSIoperationCockpitoutbound.vue?vue&type=template&id=48fb4e04"
import script from "./FSIoperationCockpitoutbound.vue?vue&type=script&lang=js"
export * from "./FSIoperationCockpitoutbound.vue?vue&type=script&lang=js"
import style0 from "./FSIoperationCockpitoutbound.vue?vue&type=style&index=0&id=48fb4e04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports